import { useEffect, useRef } from "react";

const AD_CLIENT = "ca-pub-6614673457067389";

function AdSenseUnit({ slot, format, layoutKey, className }) {
  const initialized = useRef(false);

  useEffect(() => {
    if (!slot || initialized.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      initialized.current = true;
    } catch {
      /* AdSense may be blocked or not loaded yet */
    }
  }, [slot]);

  if (!slot) return null;

  return (
    <div className={className} aria-hidden={false}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        {...(layoutKey ? { "data-ad-layout-key": layoutKey } : {})}
      />
    </div>
  );
}

/** Horizontal / responsive display unit (e.g. footer). Set REACT_APP_ADSENSE_DISPLAY_SLOT in .env */
export function AdSenseDisplay({ className }) {
  return (
    <AdSenseUnit
      className={className}
      slot={process.env.REACT_APP_ADSENSE_DISPLAY_SLOT}
      format="auto"
    />
  );
}

/** In-feed fluid unit (e.g. marketplace). Set REACT_APP_ADSENSE_FLUID_SLOT in .env */
export function AdSenseFluid({ className }) {
  return (
    <AdSenseUnit
      className={className}
      slot={process.env.REACT_APP_ADSENSE_FLUID_SLOT}
      format="fluid"
      layoutKey={process.env.REACT_APP_ADSENSE_FLUID_LAYOUT_KEY}
    />
  );
}
